import React, { useEffect, useState } from 'react';
import AdminHeader from '../Header/AdminHeader';
import AdminFooter from '../Footer/AdminFooter';
import AdminLeftMenu from '../Navbar/AdminLeftMenu';
import { Link, useParams } from 'react-router-dom';
import { userloginDetails } from '../Utils/AdminAuth';
import { HOST_URL } from '../Dashboard/api/Api';
import { server } from '../../server';
import Axios from '../../axios/Axios';

const ExtraSettings = () => {
    const lStorage = userloginDetails();
    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;
    const type = lStorage?.user?.isAdmin;
    const permissionsubadmin = lStorage?.permission?.per_value?.usermanagement?.children

    const { id, userType } = useParams();
    const [email, setEmail] = useState('');
    const [error, setError] = useState({
        errorStatus: false,
        bgColor: '',
        errorMessage: ''
    });

    const [extraParams, setExtraParams] = useState([]);
    const [minRecharge, setMinRecharge] = useState(null);
    const [monthlyCostAmount, setMonthlyCostAmount] = useState('');
    const [monthlyCostDeduct, setMonthlyCostDeduct] = useState(null);
    const [templateValue, setTemplateValue] = useState('');

    useEffect(() => {
        getUserDetails();
    }, []);

    useEffect(() => {
        if (minRecharge) {
            localStorage.setItem("minRechargeAmount", minRecharge);
        }
    }, [minRecharge]);


    const getUserDetails = async () => {
        try {
            const response = await fetch(
                `${HOST_URL}/admin_user_list.php?user_id=${userId}&method=retrieve&type=userdetails&ret_user_id=${id}&token=${userToken}`
            );
            const result = await response.json();

            if (result.success) {
                const user = result.data[0];
                setEmail(user.email);
                setTemplateValue(user.short_enble_templates || '');

                // Parse extra_param safely
                let parsedExtra = {};
                if (user.extra_param) {
                    try {
                        parsedExtra = typeof user.extra_param === 'string'
                            ? JSON.parse(user.extra_param)
                            : user.extra_param;
                    } catch (err) {
                        console.error('Invalid extra_param JSON:', err);
                    }
                }

                // Ensure extraParams is always an array
                let validExtra = [];
                if (Array.isArray(parsedExtra)) {
                    validExtra = parsedExtra;
                } else if (typeof parsedExtra === 'object' && parsedExtra !== null) {
                    validExtra = [parsedExtra]; // wrap single object in array
                }
                setExtraParams(validExtra);

                // Check for min_recharge_amount in extraParams
                let minRechargeVal = '';
                let monthlyCostAmountVal = '';
                let monthlyCostDeductVal = null;
                validExtra.forEach(obj => {
                    if (obj.hasOwnProperty('min_recharge_amount')) {
                        minRechargeVal = Number(obj['min_recharge_amount']) || '';
                    }
                    if (obj.hasOwnProperty('monthly_cost_amount')) {
                        monthlyCostAmountVal = obj['monthly_cost_amount'] || '';
                    }
                    if (obj.hasOwnProperty('monthly_cost_deduct')) {
                        monthlyCostDeductVal = obj['monthly_cost_deduct'] === 1 || obj['monthly_cost_deduct'] === true;
                    }
                });
                setMinRecharge(minRechargeVal);
                setMonthlyCostAmount(monthlyCostAmountVal);
                setMonthlyCostDeduct(monthlyCostDeductVal);

            } else {
                setError({
                    errorStatus: true,
                    bgColor: 'alert alert-danger alert-dismissible',
                    errorMessage: result.message
                });
            }
        } catch (err) {
            setError({
                errorStatus: true,
                bgColor: 'alert alert-danger alert-dismissible',
                errorMessage: err.message
            });
        }
    };

    const Submit = async () => {
        try {
            // Merge all key/value pairs from extraParams into a single object
            let mergedExtraParams = {};
            if (Array.isArray(extraParams)) {
                extraParams.forEach(paramObj => {
                    if (paramObj && typeof paramObj === 'object') {
                        Object.assign(mergedExtraParams, paramObj);
                    }
                });
            }

            // If min_recharge_amount is not already in extraParams, include it
            if (!mergedExtraParams.hasOwnProperty('min_recharge_amount') && minRecharge) {
                mergedExtraParams.min_recharge_amount = String(minRecharge);
            }

            mergedExtraParams.monthly_cost_amount = monthlyCostAmount ? String(monthlyCostAmount) : '';
            mergedExtraParams.monthly_cost_deduct = monthlyCostDeduct ? 1 : 0;

            // Build final payload dynamically
            const payload = {
                user_type: type,
                extra_param: mergedExtraParams,
                retr_user_id: id,
                user_id: userId,
                method: "MinBalance",
                username: email
            };

            console.log("Submitting dynamic payload:", payload);

            // Make API request
            const { data } = await Axios.post(
                "https://napi.authkey.io/api/v1/admin/ExtraSetting",
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${userToken}`
                    }
                }
            );

            // Handle API response
            setError({
                errorStatus: true,
                bgColor: data.success
                    ? 'alert alert-success alert-dismissible'
                    : 'alert alert-danger alert-dismissible',
                errorMessage: data.message || 'Something went wrong!'
            });

            // Re-fetch details if update succeeded
            if (data.success) {
                await getUserDetails();
            }

        } catch (err) {
            setError({
                errorStatus: true,
                bgColor: 'alert alert-danger alert-dismissible',
                errorMessage: err.response?.data?.message || err.message
            });
        }
    };
    const formatLabel = (key) =>
        key
            .replace(/_/g, " ")
            .replace(/\b\w/g, (char) => char.toUpperCase());


    return (
        <div>
            <div className="wrapper">
                <AdminLeftMenu />
                <div className="main">
                    <AdminHeader />
                    <main className="content">
                        <div className="container-fluid p-0">
                            <div className="row mb-2 mb-xl-3">
                                <div className="col-auto d-none d-sm-block">
                                    <h3>Extra Settings &nbsp;<strong className="text-info">{email}</strong></h3>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12">
                                    <div className="card">

                                        {/* Breadcrumb nav */}
                                        <div className="card-header bg-white px-4 py-3">
                                            <nav aria-label="breadcrumb">
                                                <ol className="breadcrumb bg-transparent p-0 m-0 flex-wrap">
                                                    <Link to={`/admin/user-details/${id}/${userType}`}><li className="breadcrumb-item">User Details</li></Link>
                                                    {(type === "admin" || type === "emp" || type === "reseller" || (type === "subadmin" && permissionsubadmin.transactiondetails)) && <Link to={`/admin/user-transaction-details/${id}/${userType}`}><li className="breadcrumb-item">Transaction Details</li></Link>}
                                                    {(type === "admin" || type === "emp" || type === "reseller" || (type === "subadmin" && permissionsubadmin.addeditprice)) && <Link to={`/admin/user-price-details/${id}/${userType}?channel=whatsapp`}><li className="breadcrumb-item">Add Price</li></Link>}
                                                    {(type === "admin" || (type === "subadmin" && permissionsubadmin.awssettings)) && <Link to={`/admin/aws-settings/${id}/${userType}?channel=whatsapp`}><li className="breadcrumb-item">AWS Settings</li></Link>}
                                                    {(type === "admin" || (type === "subadmin" && permissionsubadmin.billingmode)) && <Link to={`/admin/user-billing-mode/${id}/${userType}`}><li className="breadcrumb-item">Billing Mode</li></Link>}
                                                    {(type === "admin" || type === "emp" || type === "reseller" || (type === "subadmin" && permissionsubadmin.addeditcredit)) && <Link to={`/admin/user-add-price/${id}/${userType}`}><li className="breadcrumb-item">Add Credit</li></Link>}
                                                    {(type === "admin" || (type === "subadmin" && permissionsubadmin.entitybypass)) && <Link to={`/admin/user-entity-pass/${id}/${userType}`}><li className="breadcrumb-item">Entity By Pass</li></Link>}
                                                    {(type === "admin" || (type === "subadmin" && permissionsubadmin.changecurrency)) && <Link to={`/admin/change-currency/${id}/${userType}`}><li className="breadcrumb-item">Change Currency</li></Link>}
                                                    {(type === "admin" || (type === "subadmin" && permissionsubadmin.bulksmsroutesetting)) && <Link to={`/admin/bulk-sms-route/${id}/${userType}`}><li className="breadcrumb-item">Bulk Sms Route Setting</li></Link>}
                                                    {(type === "admin" || (type === "subadmin" && permissionsubadmin.autoshorturl)) && <Link to={`/admin/api-auto-short-url/${id}/${userType}`}><li className="breadcrumb-item">Auto Short URL</li></Link>}
                                                    {(type === "admin" || (type === "subadmin" && permissionsubadmin.extrasettings)) && <Link to={`/admin/extra-settings/${id}/${userType}`}><li className="breadcrumb-item active">Extra Settings</li></Link>}
                                                    {(type === "admin" || (type === "subadmin" && permissionsubadmin.mmlite)) && <Link to={`/admin/mmlite/${id}/${userType}`}><li className="breadcrumb-item">MMLite</li></Link>}
                                                    {(type === "admin" || (type === "subadmin" && permissionsubadmin.aibot)) && <Link to={`/admin/ai-bot/${id}/${userType}`}><li className="breadcrumb-item">AI Bot</li></Link>}
                                                    {(type === "admin" || (type === "subadmin" && permissionsubadmin.edituserplan)) && <Link to={`/admin/edit-user-plan/${id}/${userType}`}><li className="breadcrumb-item">Edit User Plan</li></Link>}
                                                </ol>
                                            </nav>
                                        </div>

                                        {/* Form body */}
                                        <div className="card-body p-4">
                                            {error.errorStatus && (
                                                <div className={error.bgColor} role="alert">
                                                    <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                                        <span aria-hidden="true">×</span>
                                                    </button>
                                                    <div>{error.errorMessage}</div>
                                                </div>
                                            )}

                                            {/* Dynamic fields from extra_param */}
                                            {extraParams.map((param, index) =>
                                                Object.entries(param)
                                                    .filter(([key]) => !['monthly_cost_amount', 'monthly_cost_deduct'].includes(key))
                                                    .map(([key, value]) => (
                                                        <div className="form-group row align-items-center" key={key}>
                                                            <label className="col-12 col-sm-4 col-md-3 col-form-label font-weight-bold">
                                                                {formatLabel(key)} :
                                                            </label>
                                                            <div className="col-12 col-sm-8 col-md-6">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={value}
                                                                    onChange={(e) => {
                                                                        const newExtra = [...extraParams];
                                                                        newExtra[index][key] = e.target.value;
                                                                        setExtraParams(newExtra);
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    ))
                                            )}

                                            {/* Min recharge fallback */}
                                            {!extraParams.some(obj => obj.hasOwnProperty("min_recharge_amount")) && (
                                                <div className="form-group row align-items-center">
                                                    <label className="col-12 col-sm-4 col-md-3 col-form-label font-weight-bold">
                                                        Min Recharge Amount :
                                                    </label>
                                                    <div className="col-12 col-sm-8 col-md-6">
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            value={minRecharge || ''}
                                                            placeholder="Enter minimum recharge amount"
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                if (/^\d*$/.test(value)) setMinRecharge(value);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            )}

                                            {/* Monthly Cost Amount */}
                                            <div className="form-group row align-items-center">
                                                <label className="col-12 col-sm-4 col-md-3 col-form-label font-weight-bold">
                                                    Monthly Cost Amount :
                                                </label>
                                                <div className="col-12 col-sm-8 col-md-6">
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={monthlyCostAmount}
                                                        placeholder="Enter monthly cost amount"
                                                        onChange={(e) => {
                                                            const val = e.target.value;
                                                            if (/^\d*$/.test(val)) setMonthlyCostAmount(val);
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                            {/* Monthly Cost Deduct */}
                                            <div className="form-group row align-items-center">
                                                <label className="col-12 col-sm-4 col-md-3 col-form-label font-weight-bold">
                                                    Monthly Cost Deduct :
                                                </label>
                                                <div className="col-12 col-sm-8 col-md-6">
                                                    <div className="d-flex align-items-center">
                                                        <div className="form-check form-check-inline mr-4">
                                                            <input
                                                                type="radio"
                                                                className="form-check-input"
                                                                id="monthlyCostDeductYes"
                                                                name="monthlyCostDeduct"
                                                                checked={monthlyCostDeduct === true}
                                                                onChange={() => setMonthlyCostDeduct(true)}
                                                            />
                                                            <label className="form-check-label" htmlFor="monthlyCostDeductYes">
                                                                Yes
                                                            </label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                type="radio"
                                                                className="form-check-input"
                                                                id="monthlyCostDeductNo"
                                                                name="monthlyCostDeduct"
                                                                checked={monthlyCostDeduct === false}
                                                                onChange={() => setMonthlyCostDeduct(false)}
                                                            />
                                                            <label className="form-check-label" htmlFor="monthlyCostDeductNo">
                                                                No
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Submit */}
                                            <div className="d-flex justify-content-end mt-4">
                                                <button type="button" onClick={Submit} className="btn btn-primary">
                                                    Submit
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                    <AdminFooter />
                </div>
            </div>
        </div>
    );
};

export default ExtraSettings;
